export default __webpack_public_path__ + "static/media/roadmap_check.5ff8ea53.svg";